module.exports = __webpack_public_path__ + "img/centrifuge-C.0fd46a61.png";